import React from "react";
import { ParallaxBanner } from "react-scroll-parallax";
import Img from "gatsby-image/withIEPolyfill";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import "moment/locale/fr-ca";
import "moment/locale/en-ca";

import SEO from "../components/seo";

const VergerPage = ({data}) => {

  moment.locale(process.env.GATSBY_LANG + "-ca");

  let apples = {};
  data.allContentfulApple.edges.forEach(a => {
    let apple = a.node;
    const date = moment(apple.startTime);
    apple.dateSort = date.format("YYYY-MM-DD");
    apple.dateStr = date.format("D MMMM");
    
    if (apple.dateSort in apples) {
      apples[apple.dateSort] = [...apples[apple.dateSort], apple];
    } else {
      apples[apple.dateSort] = [apple];
    }
  });
  const sortedAppleKeys = Object.keys(apples).sort((a, b) => moment(a, "YYYY-MM-DD").unix() - moment(b, "YYYY-MM-DD").unix());


  const getImageFluid = filename => {
    return data.allFile.edges.find(node => node.node.childImageSharp.fluid.originalName === filename).node.childImageSharp.fluid;
  }

  const getText = key => {
    const arr = data.allContentfulTitle.edges;
    const node = arr.find(n => n.node.key === key);

    return node ? node.node.text.text : null;
  }

  return (
    <>
      <SEO title="Nos pommes" />

      <ParallaxBanner
        className="bg-ref-dark"
        style={{
          height: "70vh"
        }}
        layers={[
          {
            amount: -0.2,
            children: (
              <div className="parallax-children-20">
                <Img
                  fluid={data.header.childImageSharp.fluid}
                  objectFit="cover"
                  objectPosition="50% 50%"
                  style={{ height: '100%' }}
                />
              </div>
            )
          }
        ]}
      >
        <div className="parallax-overlay overlay-black">
          <div className="wrapper wrapper-page-header">
            <div className="home-overlay-text">
              <h1>{getText('nos-pommes')}</h1>
            </div>
          </div>
        </div>
      </ParallaxBanner>

      <div className="wrapper section bg-ref-light">
        <h2>Découvrez nos pommes biologiques</h2>
        <p>* Les dates mentionnées ci-dessous sont estimées et planifiées en fonction des degrés-jours enregistrés en 2023 jusqu’au début du mois d’août dans la région de Saint-Joseph-du-Lac. Elle sont sujettes à de légers changements en fonction des températures des prochaines semaines.</p>



        <div id="pommes_dispo_container">
          {sortedAppleKeys.map(date => (
            <div className="pomme_date_break" key={"pomme-break-"+date}><div className="break_date">{getText('a-partir')} {moment(date).format("LL")}</div>
              {apples[date].map(apple => {
                return (<div className={`pomme_dispo_card ${(!apple.disponible && !apple.avenir) && "pomme_not_available"}`} 
                  style={{backgroundImage: `url(../images-pommes/${apple.imgUrl})`}}
                  key={"pomme-card-"+apple.key}>
                    <div className="pomme-card-title">{apple.title}</div>
                    {(apple.disponible || apple.avenir) ? (
                      <>
                        {apple.avenir && <div className="pomme-card-bullets"><FontAwesomeIcon icon="hourglass"/> {getText('a-venir')}</div>}
                        {apple.autocueillette && <div className="pomme-card-bullets"><FontAwesomeIcon icon="apple-alt"/> {getText('autocueillette')}</div>}
                        {apple.kiosque && <div className="pomme-card-bullets"><FontAwesomeIcon icon="home"/> {getText('au-kiosque')}</div>}
                      </>
                    ) : (
                      <div className="pomme-card-bullets"><FontAwesomeIcon icon="times"/> {apple.pasfloraison ? getText('pas-floraison') : getText('non-disponible')}</div>
                    )}
                </div>)
              })}
            </div>
          ))}
        </div>


        <h2>La floraison des pommes</h2>
        <p>La floraison arrive à date variable à chaque année. Tout est en fonction de la température observée en avril et mai (nombre de degré-jour). S'il fait plus que chaud, la floraison sera précoce. S'il fait plus froid, elle sera tardive. La floraison se produit généralement entre les 18 et 30 mai et sa durée est de 7 à 10 jours. Les fleurs pollinisées par les abeilles apparaissent dans toute leur splendeur. Ces fleurs dégagent une odeur unique et exquise dans le verger.</p>


      </div>

      {/* <ParallaxBanner
        className="bg-ref-dark"
        style={{
          height: "50vh"
        }}
        layers={[
          {
            amount: 0.2,
            children: (
              <div className="parallax-children-20">
                <Img
                  fluid={data.prunes.childImageSharp.fluid}
                  objectFit="cover"
                  objectPosition="50% 50%"
                />
              </div>
            )
          }
        ]}
      ></ParallaxBanner> */}

    </>
  );
}

export default VergerPage;

export const query = graphql`
  query {
    header: file(relativePath: { eq: "vj-bg-01.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1500) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }
    allContentfulTitle {
      edges {
        node {
          key
          text {
            text
          }
        }
      }
    }
    allContentfulApple {
      edges {
        node {
          key
          title
          imgUrl
          disponible
          avenir
          kiosque
          autocueillette
          pasfloraison
          startTime
        }
      }
    }
  }
`;

// export const query = graphql`
//   query {
//     header: file(relativePath: { eq: "vj-bg-01.jpg" }) {
//       childImageSharp {
//         fluid(maxWidth: 1500) {
//           ...GatsbyImageSharpFluid_noBase64
//         }
//       }
//     }
//     prunes: file(relativePath: { eq: "prunes_01.JPG" }) {
//       childImageSharp {
//         fluid(maxWidth: 1500) {
//           ...GatsbyImageSharpFluid_noBase64
//         }
//       }
//     }
//     allFile(filter: {
//         extension: {eq: "png"},
//         sourceInstanceName: {eq: "images"}
//       })
//     {
//       edges {
//         node {
//         childImageSharp {
//             fluid(maxWidth: 300, quality: 50) {
//               originalName
//               ...GatsbyImageSharpFluid
//             }
//           }
//         }
//       }
//     }
//   }
// `;
